import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    prompt: String,
  };

  select() {
    const textarea = this.element.closest('.o-form-field-wrapper').querySelector('textarea');
    textarea.value = this.promptValue;
    textarea.focus();
  }
}
